import CitySEOHead from "@/components/feature/CitySEOHead";
import ClarksvilleHeroSection from "./components/HeroSection";
import ClarksvilleStickyNav from "./components/StickyNav";
import ClarksvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import ClarksvilleServicesSection from "./components/ServicesSection";
import ClarksvilleLocalAreaSection from "./components/LocalAreaSection";
import ClarksvilleTravelTimingSection from "./components/TravelTimingSection";
import ClarksvilleDestinationsSection from "./components/DestinationsSection";
import ClarksvilleTestimonialsSection from "./components/TestimonialsSection";
import ClarksvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ClarksvilleComparisonSection from "./components/ComparisonSection";
import ClarksvilleMistakesSection from "./components/MistakesSection";
import ClarksvilleHowItWorksSection from "./components/HowItWorksSection";
import ClarksvilleFAQSection, { faqs } from "./components/FAQSection";
import ClarksvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ClarksvilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Clarksville, TN — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Clarksville, TN and Montgomery County — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Fort Campbell soldiers, 101st Airborne families, Austin Peay students, and Clarksville residents. No Nashville agency drive required.";

const servicesList = [
  { name: "Emergency Passport Clarksville TN", description: "Urgent passport processing for Fort Campbell soldiers, 101st Airborne families, and Clarksville travelers with immediate international departure needs, as fast as 24 hours." },
  { name: "Expedited Passport Renewal Clarksville TN", description: "Fast passport renewal for Clarksville and Montgomery County residents — 2-9 business days with courier submission." },
  { name: "New Passport Clarksville TN", description: "First-time passport application assistance for Clarksville-area residents with acceptance facility scheduling support." },
  { name: "Child Passport Clarksville TN", description: "Minor passport services for Fort Campbell and Montgomery County families, with parental consent guidance and step-by-step acceptance clerk support." },
  { name: "Lost Stolen Passport Replacement Clarksville TN", description: "Fast replacement of lost or stolen passports for Clarksville and Fort Campbell residents." },
  { name: "Military PCS Passport Services Clarksville TN", description: "Expedited passport processing for Fort Campbell soldiers and families with PCS orders, deployment leave, and OCONUS assignments." },
];

export default function ClarksvillePage() {
  return (
    <>
      <CitySEOHead
        city="Clarksville"
        state="Tennessee"
        stateAbbr="TN"
        route="/cities/clarksville"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Clarksville, Tennessee"
        geoPosition="36.5298;-87.3595"
        keywords="expedited passport Clarksville, emergency passport Clarksville TN, Fort Campbell passport, 101st Airborne passport, fast passport Tennessee, Austin Peay passport, military PCS passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
        lastModified="2026-06-09"
        serviceAreaDesc="Emergency and expedited passport services for Clarksville, TN and Montgomery County. Serving Fort Campbell soldiers, 101st Airborne families, Austin Peay State University students, and all Clarksville residents."
      />

      <div className="font-sans">
      <ClarksvilleHeroSection />
      <ClarksvilleStickyNav />
      <ClarksvilleProcessingTimeSection />
      <ClarksvilleLocalAreaSection />
      <ClarksvilleServicesSection />
      <ClarksvilleTravelTimingSection />
      <ClarksvilleDestinationsSection />
      <ClarksvilleTestimonialsSection />
      <ClarksvilleAcceptanceFacilitiesSection />
      <ClarksvilleComparisonSection />
      <ClarksvilleMistakesSection />
      <ClarksvilleHowItWorksSection />
      <ClarksvilleFAQSection />
      <ClarksvilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/clarksville" state="TN" />
      <ClarksvilleFinalCTA />
      </div>
    </>
  );
}